import React from 'react';
import {
  getStatusBadgeClass,
  getStatusIcon,
  getStatusLabel,
} from '../../utils/transcriptionStatus';

const JobStatusBadge = ({ status, className = '', showIcon = true }) => {
  const badgeClass = getStatusBadgeClass(status);
  const label = getStatusLabel(status);
  const icon = showIcon ? getStatusIcon(status) : '';

  return (
    <span className={`${badgeClass} ${className}`.trim()}>
      {icon && <span className="mr-1">{icon}</span>}
      {label}
    </span>
  );
};

export default JobStatusBadge;
